import React from "react";
import SportBookInner from "./SportBookInner";
import { Accordion, Row } from "react-bootstrap";
import { FaRegArrowAltCircleUp } from "react-icons/fa";
import { isEmpty } from "lodash";
import { Reorder } from "framer-motion";
const SportBookMatchInner = ({
  updatedData,
  parly,
  setSelectSpark,
  scrollHeight,
  myRef,
  scrollId,
  betSlipObject,
  handelChange,
  setSelected,
  selectSpark,
  showBetDialog,
  selected,
  sportBookCheck,
  parlyBet,
  detail,
  addToFavioute,
  position,
  closed,
  setAnimateReorder,animateReorder
}) => {
  return (
    <Reorder.Group
      axis="y"
      onReorder={() => {}}
      values={updatedData}
      layout // ✅ enable layout animation
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className={`sport-listing ${parly ? "sport-parly-list" : ""}`}
    >
      {updatedData?.map((item, index) => {
        if (item?.sportsBookSelection?.length > 0) {
          return (
            <Reorder.Item
              dragListener={false}
              layout
              key={item.apiSiteSelectionId}
              transition={animateReorder ? {} : { duration: 0 }}
              onAnimationComplete={() => setAnimateReorder(false)}
              value={item}
              drag="y"
            >
              <Accordion
                key={item?.apiSiteSelectionId}
                onSelect={(e) => {
                  if (selectSpark?.includes(e)) {
                    setSelectSpark((prev) => {
                      return prev?.filter((res) => {
                        return res !== e;
                      });
                    });
                  } else {
                    setSelectSpark((prev) => {
                      return [...prev, e];
                    });
                    setTimeout(() => {
                      setSelectSpark((prev) => {
                        return prev?.filter((res) => {
                          return res !== e;
                        });
                      });
                    }, 1000);
                  }
                }}
                defaultActiveKey={[
                  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                ]}
              >
                <Accordion.Item eventKey={index}>
                  <Accordion.Header
                    onClick={(e) => {
                      if (closed.includes(index)) {
                        e.stopPropagation(); // Prevent accordion from toggling
                      }
                    }}
                    style={{ scrollMarginTop: scrollHeight }}
                    ref={index == scrollId ? myRef : null}
                  >
                    {parly ? (
                      <FaRegArrowAltCircleUp
                        size={25}
                        style={{ margin: "1px 6px" }}
                      />
                    ) : (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          setAnimateReorder(true);
                          addToFavioute(detail?.eventId, "SportBook", item?.id);
                        }}
                        style={{ width: "4.2rem", background: "" }}
                        className={`fave  bg-star-sprit-black  start-0 ${
                          !isEmpty(
                            detail?.favourites?.find((res) => {
                              return res?.favoriteMarketId == item?.id;
                            })
                          )
                            ? "animate"
                            : ""
                        }`}
                      ></div>
                    )}
                    <span style={{ width: "80%" }}>{item?.marketName} </span>
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    {!closed.includes(index) && (
                      <div className="sports-listing-score">
                        {(item?.apiSiteStatus == "SUSPENDED" ||
                          item?.marketStatus != 1) && (
                          <div
                            style={{
                              background: "rgb(90 94 98/.8)",
                              position: "absolute",
                              width: "100%",
                              height: "100%",
                              zIndex: "999",
                              fontSize: ".7857142857142857rem",
                              borderBottomLeftRadius: ".5rem",
                              borderBottomRightRadius: ".5rem",
                              color: "white",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            Suspend
                          </div>
                        )}
                        <Row
                          className={`gx-1 
                     
                      `}
                        >
                          {/* ${
                          item?.apiSiteStatus == "SUSPENDED" ||
                          item?.marketStatus != 1 
                            ? "sports-book-disabled"
                            : ""
                        } */}
                          {item?.sportsBookSelection?.map((res) => {
                            if (Number(res?.odds) > 0) {
                              let newPosition = "";
                              if (
                                showBetDialog &&
                                betSlipObject?.playType == "sportBook" &&
                                item?.id == selected
                              ) {
                                let backProfit =
                                  (Number(betSlipObject?.odds) - 1) *
                                  Number(betSlipObject?.bidPrice);
                                let backLoss = Number(betSlipObject?.bidPrice);
                                if (res?.id == betSlipObject?.object?.id) {
                                  newPosition =
                                    Math.abs(res?.position) > 0
                                      ? Number(backProfit) +
                                        Number(res.position)
                                      : Number(backProfit);
                                } else {
                                  newPosition =
                                    Math.abs(res?.position) > 0
                                      ? Number(res?.position) - Number(backLoss)
                                      : -Number(backLoss);
                                }
                              }
                              let activeClass = parly
                                ? sportBookCheck(parlyBet, detail, res)
                                : betSlipObject?.teamName ==
                                    res?.selectionName &&
                                  betSlipObject?.odds == res?.odds &&
                                  item?.marketName ==
                                    betSlipObject?.item?.marketName &&
                                  showBetDialog
                                ? "back-active"
                                : "";
                              let conditionPosition =
                                showBetDialog &&
                                betSlipObject?.playType == "sportBook" &&
                                item?.id == selected &&
                                Number(betSlipObject?.bidPrice) > 0
                                  ? true
                                  : false;
                              let oldObject =
                                item?.oldSportsBookSelection?.find((obj) => {
                                  return obj?.id == res?.id;
                                });

                              let conditionShowPositon = !isEmpty(
                                position?.find((res) => {
                                  return (
                                    res?.marketId ==
                                    `${item?.betfairEventId}S${item?.id}`
                                  );
                                })
                              );

                              // let lock =
                              // res?.isActive != 1 ||
                              // item?.apiSiteStatus == "SUSPENDED" ||
                              // item?.marketStatus != 1 || 0.5 >= Number(res?.odds) || res?.selectionName.includes(0.5)

                              return (
                                <SportBookInner
                                  oldObject={oldObject}
                                  conditionShowPositon={conditionShowPositon}
                                  res={res}
                                  handelChange={handelChange}
                                  item={item}
                                  index={index}
                                  parly={parly}
                                  activeClass={activeClass}
                                  newPosition={newPosition}
                                  conditionPosition={conditionPosition}
                                  setSelected={setSelected}
                                  selectSpark={selectSpark}
                                />
                              );
                            }
                          })}
                        </Row>
                      </div>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Reorder.Item>
          );
        }
      })}
    </Reorder.Group>
  );
};

export default SportBookMatchInner;
